import toast from "react-hot-toast";
import * as api from "../Api";

export const createInvestment = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting investment for approval...");
    const { data } = await api.createInvestment(postData);
    dispatch({ type: "CREATE_INVESTMENT", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
export const getAllInvestment = () => async (dispatch) => {
  try {
    const { data } = await api.getInvestments();
    dispatch({ type: "GET_ALL_INVESTMENTS", payload: data });
  } catch (error) {}
};

export const approveInvestment = (id, postData) => async (dispatch) => {
  let approvingId;
  try {
    approvingId = toast.loading("Saving changes...");
    await api.updateInvestment(id, postData);
    dispatch({ type: "APPROVE_INVESTMENT", payload: id });
    toast.remove(approvingId);
    toast.success("Changes saved successfully");
  } catch (error) {
    toast.remove(approvingId);
    toast.error(error.message);
  }
};

export const deleteInvestment = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting Investment...");
    await api.deleteInvestment(id);
    dispatch({ type: "DELETE_INVESTMENT", payload: id });
    toast.remove(deletingId);
    toast.success("Investment Successfully deleted");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
